import { graphql } from "gatsby";
import React, { useCallback } from "react";
import Image from "../atoms/image";
import { Link } from "../atoms/link";
import classNames from "classnames";
import { eventInternalLinkClick } from "../../utility/data-layer";

const BadgePDP = ({ data, className, pagePath }) => {
  const onClickBadgePDP = useCallback(() => {
    eventInternalLinkClick({
      click_element: "pdp_gallery_badge",
      slug: pagePath,
    });
  }, [pagePath]);
  return (
    <Link
      className={classNames(
        className,
        "pdp-product-gallery__badge",
        data?.hooverStImage?.image?.node?.probeInfo?.width &&
          data?.hooverStImage?.image?.node?.probeInfo?.height &&
          data?.hooverStImage?.image?.node?.probeInfo?.width !==
            data?.hooverStImage?.image?.node?.probeInfo?.height &&
          "pdp-product-gallery__badge--vertical"
      )}
      to={data.link}
      target={data.hooverStTarget?.target?.[0]}
      onClick={() => onClickBadgePDP()}
    >
      <Image
        //className="pdp-product-gallery__badge pdp-product-gallery__badge--vertical"
        image={data.hooverStImage?.image}
        objectPosition={`${data.hooverStImage.focuslr?.[0] || "center"} ${
          data.hooverStImage.focustb?.[0] || "center"
        }`}
        alt={data.image?.value?.description || ""}
      />
    </Link>
  );
};
export default BadgePDP;
export const fragment = graphql`
  fragment ProductBadgePDPFragment on LiferayBadgePdp {
    id
    skuList
    link
    hooverStTarget {
      target
    }
    hooverStImage {
      focuslr
      focustb
      image {
        node {
          publicURL
          gatsbyImageData(layout: FULL_WIDTH)
          probeInfo {
            width
            height
          }
        }
        value {
          description
        }
      }
    }
  }
`;
